import { render, staticRenderFns } from "./Protect.vue?vue&type=template&id=c52078ee"
import script from "./Protect.vue?vue&type=script&lang=js"
export * from "./Protect.vue?vue&type=script&lang=js"
import style0 from "./Protect.vue?vue&type=style&index=0&id=c52078ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports